'use strict';

module Patersons {

    export interface ChangePasswordCtrlScope extends ng.IScope {
        changePasswordDetails: ChangePasswordDetails
        changePasswordForm: ng.IFormController;
        errorHandler: any;
        events: Patersons.ChangePasswordCtrl;
        isBusy: boolean;
        passwordInputType: string;
        isValidPassword: boolean;
    }

    export class ChangePasswordCtrl extends IdentityBaseCtrl {

        scope: Patersons.ChangePasswordCtrlScope;
        location: ng.ILocationService;
        window: ng.IWindowService;
        state: angular.ui.IStateService;
        stateParams: angular.ui.IStateProvider;
        http: ng.IHttpService;
        identityService: Patersons.IdentityService;
        static $inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'identityService', 'navigationService'];

        constructor($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, identityService, navigationService) {
            super($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.scope = $scope;
            this.location = $location;
            this.window = $window;
            this.state = $state;
            this.stateParams = $stateParams;
            this.http = $http;
            this.identityService = identityService;
            this.scope.events = this;
            
            this.scope.passwordInputType = "password";

            this.scope.isBusy = false;

            this.scope.changePasswordDetails = new ChangePasswordDetails;
        }
        togglePasswordVisibility() {
            
            if (this.scope.passwordInputType === "password") {
                this.scope.passwordInputType = "text"
            } else {
                this.scope.passwordInputType = "password"
            }
        }
        onValidation = (isValid: boolean) => {
            if(this.scope){
                this.scope.isValidPassword = isValid;
            }
        }
        changePassword() {
            this.scope.$broadcast('show-errors-check-validity');

            if (this.scope.changePasswordForm.$invalid) {
                return;
            }

            this.scope.isBusy = true;

            this.identityService.changePassword(this.scope.changePasswordDetails)
                .then((result) => {
                    location.href = '/dashboard';
                },
                (reason) => {
                    this.scope.errorHandler = reason.data;
                })
                .finally(() => {
                    this.scope.isBusy = false;
                });
        }


    }
}
